function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 6,
  fill: "#EC6A5F"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 5.5,
  stroke: "#000",
  strokeOpacity: 0.25
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 6,
  r: 6,
  fill: "#F5C04D"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 6,
  r: 5.5,
  stroke: "#000",
  strokeOpacity: 0.25
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 6,
  r: 6,
  fill: "#62C755"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 6,
  r: 5.5,
  stroke: "#000",
  strokeOpacity: 0.25
});

var SvgCodeWindowControls = function SvgCodeWindowControls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 12,
    viewBox: "0 0 52 12",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCA1MiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNiIgY3k9IjYiIHI9IjYiIGZpbGw9IiNFQzZBNUYiLz4KPGNpcmNsZSBjeD0iNiIgY3k9IjYiIHI9IjUuNSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLW9wYWNpdHk9IjAuMjUiLz4KPGNpcmNsZSBjeD0iMjYiIGN5PSI2IiByPSI2IiBmaWxsPSIjRjVDMDREIi8+CjxjaXJjbGUgY3g9IjI2IiBjeT0iNiIgcj0iNS41IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utb3BhY2l0eT0iMC4yNSIvPgo8Y2lyY2xlIGN4PSI0NiIgY3k9IjYiIHI9IjYiIGZpbGw9IiM2MkM3NTUiLz4KPGNpcmNsZSBjeD0iNDYiIGN5PSI2IiByPSI1LjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS1vcGFjaXR5PSIwLjI1Ii8+Cjwvc3ZnPgo=";
export { SvgCodeWindowControls as ReactComponent };